import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: '8efa0320-44ea-4dbd-9338-eb35aa392c8e',
    authority: 'https://login.microsoftonline.com/34ee68df-a357-4d06-88e9-d1cca79633f9/',
    redirectUri: 'http://localhost:3000',
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email']
};